<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    :footer-hide="true"
    width="700"
    class-name="invoice-apply-detail-modal"
    @on-visible-change="onVisibleChange"
  >
    <div class="modal-header">
      <span class="modal-title">申请开票详情</span>
    </div>

    <div class="modal-body">
      <!-- 开票状态详情 -->
      <div class="section">
        <div class="section-title">开票状态详情</div>

        <!-- 已驳回 -->
        <div v-if="data.status === 4" class="status-bar rejected">
          <span class="status-tag">已驳回</span>
          <span class="status-desc">驳回原因：{{ data.reject_reason || '店铺主体信息校验异常，请确认店铺资质完整有效后重新申请开票。' }}</span>
        </div>

        <!-- 开票中 -->
        <div v-else-if="data.status === 1" class="status-bar applying">
          <span class="status-tag">开票中</span>
          <span class="status-desc">平台正在审核您的开票申请，请耐心等待，如有问题请咨询在线客服</span>
          <span class="service-link" @click="onContactService">咨询客服</span>
        </div>

        <!-- 已开票 -->
        <div v-else-if="data.status === 2" class="status-bar invoiced">
          <span class="status-tag">已开票</span>
          <span class="status-desc">您好！发票已推送至您的电子邮箱 {{ data.send_mail || '-' }}，请注意查收</span>
        </div>

        <!-- 状态信息列表（申请中/已驳回/已开票 都显示） -->
        <div class="info-list">
          <div class="info-row">
            <span class="info-label">申请日期：</span>
            <span class="info-value">{{ data.create_time || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">发票类型：</span>
            <span class="info-value">{{ taxTypeText(data.tax_type) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">收票邮箱：</span>
            <span class="info-value">{{ data.send_mail || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">开票金额：</span>
            <span class="info-value">¥{{ data.amount || '0.00' }}</span>
          </div>
        </div>
      </div>

      <!-- 开票主体信息（申请中/已驳回 显示） -->
      <div v-if="data.status !== 2" class="section">
        <div class="section-title">开票主体信息</div>
        <div class="title-info">
          <div class="info-row">
            <span class="info-label">抬头类型：</span>
            <span class="info-value">{{ titleInfo.type == 2 ? '企业' : '个人' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">发票抬头：</span>
            <span class="info-value">{{ titleInfo.title || '-' }}</span>
          </div>
          <div v-if="titleInfo.type == 2" class="info-row">
            <span class="info-label">税号：</span>
            <span class="info-value">{{ titleInfo.tax_number || '-' }}</span>
          </div>
          <div v-if="titleInfo.type == 2" class="info-row">
            <span class="info-label">开户银行：</span>
            <span class="info-value">{{ titleInfo.bank_name || '-' }}</span>
          </div>
          <div v-if="titleInfo.type == 2" class="info-row">
            <span class="info-label">银行账号：</span>
            <span class="info-value">{{ titleInfo.bank_account || '-' }}</span>
          </div>
          <div v-if="titleInfo.type == 2" class="info-row">
            <span class="info-label">企业电话：</span>
            <span class="info-value">{{ titleInfo.phone || '-' }}</span>
          </div>
          <div v-if="titleInfo.type == 2" class="info-row">
            <span class="info-label">企业地址：</span>
            <span class="info-value">{{ titleInfo.company_address || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 开票明细（申请中/已驳回 显示） -->
      <div v-if="data.status !== 2" class="section">
        <div class="section-title">开票明细</div>
        <div class="detail-table-wrap">
          <table class="detail-table">
            <colgroup>
              <col style="width: 180px" />
              <col style="width: 120px" />
              <col style="width: 100px" />
              <col style="width: 120px" />
            </colgroup>
            <thead>
              <tr>
                <th>开票订单</th>
                <th>收益类型</th>
                <th>账期</th>
                <th>开票金额</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in detailList" :key="idx">
                <td>{{ item.order_no }}</td>
                <td>{{ typeText(item.type) }}</td>
                <td>{{ item.period }}</td>
                <td>¥{{ item.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 发票图片（已开票 显示） -->
      <div v-if="data.status === 2" class="section invoice-image-section">
        <div class="invoice-image-box">
          <img
            v-if="data.tax_file"
            :src="data.tax_file"
            class="invoice-image"
            alt="发票"
          />
          <div v-else class="invoice-image-placeholder">
            <img
              src="https://img.hongli.xingjuju.com/yichuanghub/zone/index/invoice-placeholder.jpg"
              class="invoice-image"
              alt="发票"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="modal-footer">
      <!-- 已驳回 -->
      <template v-if="data.status === 4">
        <div class="btn cancel" @click="onCancel">取消</div>
        <div class="btn outline" @click="onCancelApply">撤销申请</div>
        <div class="btn confirm" @click="onReApply">重新申请</div>
      </template>

      <!-- 开票中 -->
      <template v-else-if="data.status === 1">
        <div class="btn confirm" @click="onCancel">我知道了</div>
      </template>

      <!-- 已开票 -->
      <template v-else-if="data.status === 2">
        <div class="btn confirm" @click="onDownload">下载电子发票文件</div>
      </template>
    </div>
    <chat ref="chat"></chat>
  </Modal>
</template>

<script>
import Chat from '@/components/Chat.vue'
export default {
  name: 'InvoiceApplyDetailModal',
  components: {
    Chat,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    titleInfo() {
      return this.data.title_info || {}
    },
    detailList() {
      return this.data.detail_list || []
    },
  },
  methods: {
    onVisibleChange(val) {
      this.$emit('update:visible', val)
    },
    onCancel() {
      this.$emit('update:visible', false)
    },
    onContactService() {
      this.$refs.chat.showChat()
    },
    onCancelApply() {
      this.$Modal.confirm({
        title: '确认撤销',
        content: '确定撤销该开票申请吗？',
        onOk: () => {
          this.$emit('cancel-apply', this.data)
          this.$emit('update:visible', false)
        },
      })
    },
    onReApply() {
      this.$emit('re-apply', this.data)
      this.$emit('update:visible', false)
    },
    taxTypeText(taxType) {
      return taxType == 1 ? '电子专用发票' : '电子普通发票'
    },
    feeTypeText(feeType) {
      return feeType == 1 ? '佣金扣费' : '其他'
    },
    typeText(type) {
      return type == 1 ? '商城订单结算' : '其他'
    },
    formatTaxRate(rate) {
      const r = parseFloat(rate || 0)
      if (!r) return '0%'
      return (Math.round(r * 10000) / 100).toString() + '%'
    },
    onDownload() {
      this.$emit('download', this.data)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .invoice-apply-detail-modal {
  text-align: left;
  .ivu-modal-content {
    border-radius: 8px;
  }
  .ivu-modal-body {
    padding: 0;
  }
  .ivu-modal-close {
    top: 16px;
    right: 16px;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;

  .modal-title {
    font-size: 16px;
    font-weight: bold;
    color: #1a1a1a;
  }
}

.modal-body {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;

  .section {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      font-size: 14px;
      font-weight: bold;
      color: #1a1a1a;
      margin-bottom: 12px;
    }
  }

  .status-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    border-radius: 4px;
    margin-bottom: 16px;
    flex-wrap: wrap;

    .status-tag {
      font-size: 16px;
      font-weight: bold;
      flex-shrink: 0;
    }

    .status-desc {
      font-size: 14px;
      flex: 1;
      margin-left: 16px;
    }

    .service-link {
      font-size: 14px;
      color: #0d99ff;
      cursor: pointer;
      flex-shrink: 0;

      &:hover {
        opacity: 0.8;
      }
    }

    &.rejected {
      background: #fff5f5;

      .status-tag {
        color: #ff5967;
      }

      .status-desc {
        color: #ff5967;
      }
    }

    &.applying {
      background: #f7faff;

      .status-tag {
        color: #02C160;
      }

      .status-desc {
        color: #02C160;
      }
    }

    &.invoiced {
      background: #f6fff6;

      .status-tag {
        color: #02c160;
      }

      .status-desc {
        color: #02c160;
      }
    }
  }

  .info-list {
    .info-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;
      font-size: 13px;

      &:last-child {
        margin-bottom: 0;
      }

      .info-label {
        color: #666666;
        width: 80px;
        flex-shrink: 0;
      }

      .info-value {
        color: #333333;
        flex: 1;
      }
    }
  }

  .title-info {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 0;

    .info-row {
      display: flex;
      align-items: flex-start;
      width: 50%;
      font-size: 13px;

      .info-label {
        color: #666666;
        width: 70px;
        flex-shrink: 0;
      }

      .info-value {
        color: #333333;
        flex: 1;
      }
    }
  }

  .detail-table-wrap {
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    overflow: hidden;

    .detail-table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;

      thead {
        background: #f6f7fa;

        th {
          padding: 10px 12px;
          font-size: 13px;
          color: #666666;
          font-weight: normal;
          text-align: left;
        }
      }

      tbody {
        tr {
          border-top: 1px solid #f0f0f0;

          td {
            padding: 12px;
            font-size: 13px;
            color: #333333;
          }
        }
      }
    }
  }

  .invoice-image-section {
    .invoice-image-box {
      display: flex;
      justify-content: center;
      padding: 16px;
      background: #fafafa;
      border-radius: 4px;

      .invoice-image {
        max-width: 100%;
        max-height: 400px;
        object-fit: contain;
      }
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px 24px 24px;
  border-top: 1px solid #f0f0f0;

  .btn {
    min-width: 120px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    padding: 0 20px;

    &.cancel {
      background: #ffffff;
      border: 1px solid #e3e3e3;
      color: #999999;
    }

    &.outline {
      background: #ffffff;
      border: 1px solid #ff5967;
      color: #ff5967;
    }

    &.confirm {
      background: #ff5967;
      color: #ffffff;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
